'use client'

import { AudioHTMLAttributes, forwardRef, useImperativeHandle, useRef } from 'react'

export type IAudioProps = AudioHTMLAttributes<HTMLAudioElement>

export const Audio = forwardRef<HTMLAudioElement, IAudioProps>(function Audio(props, ref) {
    const audioRef = useRef<HTMLAudioElement>(null)

    useImperativeHandle(ref, () => audioRef.current!, [])

    return <audio ref={audioRef} {...props} />
})

export const setAudioVolume = (audioElement: HTMLAudioElement | null, localVolume: number) => {
    if (!audioElement) return
    audioElement.volume = localVolume
}
